import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import authReducer from "./authSlice";
import supervisorDetailsReducer from "./supervisorDetailsSlice";
import carStatusReducer from "./carStatusSlice";
import chargerStatusReducer from "./chargerStatusSlice";
import carAllocationReducer from "./carAllocationSlice";
import checkInDetailsReducer from "./checkInDetailsSlice";
import driverDetailsSlice from "./driverDetailsSlice";
import loginDetailsSlice from "./loginDetailsSlice";
import checkInViaDriverDetailsSlice from "./checkInViaDriverDetailsSlice";
import chargerDetailsSlice from "./chargerDetailsSlice";
import paymentSlice from "./paymentSlice";
import appSlice from "./appSlice";
import selfCheckInDetailsReducer from "./selfCheckInDetailsSlice";
import featureFlagsReducer from "./featureFlagsSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  supervisorDetails: supervisorDetailsReducer,
  carStatus: carStatusReducer,
  chargerStatus: chargerStatusReducer,
  carAllocation: carAllocationReducer,
  checkInDetails: checkInDetailsReducer,
  driverDetails: driverDetailsSlice,
  loginDetails: loginDetailsSlice,
  checkInViaDriverDetails: checkInViaDriverDetailsSlice,
  chargerDetails: chargerDetailsSlice,
  payment: paymentSlice,
  app:appSlice,
  selfCheckInDetails: selfCheckInDetailsReducer,
  featureFlags: featureFlagsReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>(); // Export a hook that can be reused to resolve types

// Export the store dispatch function directly
export const storeDispatch = store.dispatch;

export default store;
